import type { CardMobileVariant } from '@/components/v3/atoms/card/card'

// Shared between the server (reads it during SSR so the first paint is correct)
// and the client (writes it on toggle). Stored as a CookieHub "Preferences"
// cookie — see use-supplier-list-view.
export const SUPPLIER_LIST_VIEW_COOKIE = 'supplierListView'

export const parseSupplierListView = (
  value?: string | null
): CardMobileVariant => (value === 'vertical' ? 'vertical' : 'landscape')
